import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import ModalStyles from '../../Global/Modals/Modal.styles';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import combineStyles from '../../../utils/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ErrorValidationStyles from './__styles__/ErrorValidation.styles';
import TypographyStyles from '../../../styles/typography';
import ButtonStyles from '../../../styles/button';
import Button from '@material-ui/core/Button';
import _isObject from 'lodash/isObject';
import _forOwn from 'lodash/forOwn';

import ErrorIcon from '@material-ui/icons/Error';
export class ErrorValidation extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired
  };
  _processErrors = errors => {
    const errorList = [];
    const processErrors = error => {
      if (error) {
        /// long story but this happens when some fields that are part of a conditional array are not required.  Do not remove
        if (_isObject(error)) {
          _forOwn(error, processErrors);
        } else {
          errorList.push(error);
        }
      }
    };
    _forOwn(errors, processErrors);
    return errorList;
  };
  render() {
    const { open, onClose, errors, classes, t } = this.props;
    const errorList = this._processErrors(errors);

    return (
      <Dialog
        open={open}
        onClose={onClose}
        classes={{ root: classnames(classes.modalRoot) }}
        scroll={'paper'}
      >
        <div className={classnames(classes.baseRoot, classes.root)}>
          <div className={classnames(classes.baseBody, classes.body)}>
            <p className={classnames(classes.headline6, classes.boldWeight)}>
              {t('Unable to process shipment')}.
            </p>
            <h3 className={classnames(classes.body1Light, classes.subHeading)}>
              {t('Please resolve the following errors')}
            </h3>
            <ul className={classes.errorList}>
              {errorList.map((error, index) => (
                <li className={classes.error} key={index}>
                  <ErrorIcon classes={{ root: classes.errorIcon }} />
                  <span
                    className={classnames(classes.body2, classes.errorText)}
                  >
                    {error}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className={classnames(classes.baseFooter, classes.footer)}>
            <Button
              color={'primary'}
              className={classes.textButton}
              onClick={onClose}
            >
              {t('Ok')}
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}
const ErrorValidationTranslated = withNamespaces()(ErrorValidation);
export default withStyles(
  combineStyles(
    ErrorValidationStyles,
    ModalStyles,
    TypographyStyles,
    ButtonStyles,
    LayoutStyles
  )
)(ErrorValidationTranslated);
